<template>
  <el-popover placement="top-start" trigger="hover" v-if="showPopover">
    <div>
      <div
        v-for="(item, itemIdx) of contentAfter"
        :key="itemIdx"
        class="lineH24"
      >
        {{ item.name }}：{{ item.value }}
      </div>
    </div>
    <small slot="reference">
      {{ text }}
    </small>
  </el-popover>

  <small v-else> {{ text }}</small>
</template>
<script>
import Util from "@/utils/index.js";
export default {
  props: {
    content: null,
    number: {
      type: Number,
      default: 10,
    },
    // prepend append
    cut: {
      type: String,
      default: "append",
    },
  },
  computed: {
    showPopover() {
      if (this.content == null || this.content === "") {
        return false;
      }
      const con = Util.tranJSONArrToString(this.content);
      if (con.length > this.number) {
        return true;
      } else {
        return false;
      }
    },
    text() {
      if (this.content == null || this.content === "") {
        return null;
      }
      const con = Util.tranJSONArrToString(this.content);
      if (con.length > this.number) {
        if (this.cut === "prepend") {
          return "..." + str.substring(con.length - this.number, con.length);
        } else {
          return con.substring(0, this.number) + "...";
        }
      } else {
        return con;
      }
    },

    contentAfter() {
      if (this.content == null || this.content === "") {
        return null;
      }
      return Util.tranJSONArrToArr(this.content);
    },
  },
};
</script>
